export default {"src":"/_next/static/media/ic-twitter.c2579bfd.svg","height":32,"width":31};